





















import { defineComponent, PropType } from 'vue-demi';
//@ts-ignore
import theme from '@zk/theme/lib/variables.scss';


export type taskOption = {
  id: number;
  questCode: string;
  questDesc: string;
  questGroup: string;
  questName: string;
  questPriority: number;
  questStatus: number;
  tenantId: number;
  userId: number;
  extend: string | null;
}

export default defineComponent({
  name: 'OverseasGuideTaskList',
  bemNS: theme.bemNS,
  props: {
    taskList: {
      type: Array as PropType<Array<taskOption>>,
      required: true
    }
  },
  setup() {

    return {

    };

  }
});
